<template>
  <fragment>
    <template v-for="(v, index) in variables">
      <b-form-group
        :key="v.id + index"
        :label="v.input_label"
        label-class="v2_font_size_20 "
      >
        <b-form-radio-group
          v-model="isPreview ? {} : v.response.value"
          :name="`${v.id}`"
          class="col-9 offset-3 text-left v2_control_radio_group"
          stacked
        >
          <b-form-radio
            v-for="(option, oIndex) in v.variableOptions"
            :value="option.id"
            :key="option.id + oIndex"
            @change="$emit('inputChanged')"
          >
            {{ option.name }}
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </template>
  </fragment>
</template>

<script>
export default {
  name: 'MultiVariableSelectOne',
  props: {
    variables: {
      type: Array,
      required: true,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
